import { useTranslation } from 'react-i18next'
import React, { Fragment, useState } from 'react'

import { useServiceOrdersActionsList } from '../../../../utils/actions/serviceOrders/list'
import Link from '../../../../components/actions/Link'
import PublicHistoryRowActions from '../_components/PublicHistoryRowActions'
import ServiceOrderCard from '../../../../containers/serviceOrders/ServiceOrderCard'
import ShowServiceOrderHistoryDetailsModal from '../_components/details/ShowServiceOrderHistoryDetailsModal'

const ServiceOrdersPublicListItem = ({ item }) => {
  const { t } = useTranslation()
  const [isShowing, setShowing] = useState(false)
  const options = useServiceOrdersActionsList(item)

  return (
    <Fragment>
      <Link block onClick={() => setShowing(true)}>
        <ServiceOrderCard item={item} />
      </Link>
      <PublicHistoryRowActions serviceOrder={item} />
      <ShowServiceOrderHistoryDetailsModal open={isShowing} onClose={() => setShowing(false)} serviceOrder={item} />
    </Fragment>
  )
}

export default ServiceOrdersPublicListItem
